module.exports = __webpack_public_path__ + "static/media/textocampanias.19b67599.png";